import { RfqStatus } from '@luminovo/http-client';

export const nonArchivableRfqStatuses: RfqStatus[] = [RfqStatus.RequestInDraft, RfqStatus.QuotationInProgress];

export const isRfqArchivable = (status: RfqStatus): boolean => !nonArchivableRfqStatuses.includes(status);
